import $ from "jquery"

const tableContent = () => {
  const init = () => {
    action()
  }

  const item = $(".js-Behandelingen__TableContent .elementor-toc__body ")
  const action = () => {
    item.on("click", function () {
      //   alert("oke")
    })
  }

  init()
}
tableContent()
